import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BillingSuboperatorsState } from './billing.suboperators.models';

export const selectBillingSuboperatorsState =
  createFeatureSelector<BillingSuboperatorsState>('billingSuboperators');

export const selectSubCpos = createSelector(
  selectBillingSuboperatorsState,
  (state) => state.subCpos,
);

export const selectSubCposLoading = createSelector(
  selectBillingSuboperatorsState,
  (state) => state.loading,
);

export const selectSubCposTotalCount = createSelector(
  selectBillingSuboperatorsState,
  (state) => state.subCposPage?.totalCount ?? 0,
);

export const selectSubCpoFilterParameters = createSelector(
  selectBillingSuboperatorsState,
  (state) => state.filterParameters,
);

export const selectSubCpoCurrentFilter = createSelector(
  selectBillingSuboperatorsState,
  (state) => state.currentFilter,
);

export const selectSubCpoPagination = createSelector(
  selectBillingSuboperatorsState,
  (state) => state.pagination,
);
